import { useEffect, useState } from "react";
import { Bike, Radio, RefreshCw } from "lucide-react";
import MapView, { RouteInfo } from "./MapView";
import { getRoute } from "./routing";
import useTracking from "./useTracking";
import { DELIVERY, VEHICLE, fmtDate } from "../lib/api";

const STALE_MS = 2 * 60 * 1000;

export default function TrackingPanel({ order }) {
  const enabled = order.delivery_method === "delivery" && !["cancelled", "pending_payment"].includes(order.status);
  const { delivery, mode } = useTracking(order.id, enabled);
  const [route, setRoute] = useState(null);
  const live = delivery?.tracking_active && delivery?.last_location;
  const dest = delivery?.destination || order.address?.location;
  const locKey = live ? `${delivery.last_location.lat},${delivery.last_location.lng}` : "";
  useEffect(() => {
    if (live && dest) getRoute(delivery.last_location, dest).then(setRoute); else setRoute(null);
  }, [locKey, dest?.lat]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!enabled || delivery === undefined) return null;
  if (!delivery) return (
    <section className="bo-card p-5" data-testid="tracking-panel">
      <h2 className="mb-1 flex items-center gap-2 font-bold"><Bike className="h-4 w-4 text-bo-green" />OBÔGO Entregas</h2>
      <p className="text-sm text-gray-500" data-testid="tracking-status">Ainda sem estafeta atribuído.</p>
    </section>
  );
  const stale = live && Date.now() - new Date(delivery.last_location.at).getTime() > STALE_MS;
  return (
    <section className="bo-card flex flex-col gap-3 p-5" data-testid="tracking-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="flex items-center gap-2 font-bold"><Bike className="h-4 w-4 text-bo-green" />OBÔGO Entregas</h2>
        <span className={`inline-flex items-center gap-1 text-xs ${mode === "live" ? "text-bo-green" : "text-gray-500"}`} data-testid="tracking-mode">
          {mode === "live" ? <Radio className="h-3 w-3" /> : <RefreshCw className="h-3 w-3" />}{mode === "live" ? "Tempo real" : "Atualização a cada 10 s"}
        </span>
      </div>
      <p className="text-sm"><strong data-testid="tracking-status">{DELIVERY[delivery.status]}</strong> · {delivery.courier_name} ({VEHICLE[delivery.vehicle]})</p>
      {live ? (
        <>
          <MapView height={280} route={route} markers={[{ key: "c", pos: delivery.last_location, icon: "courier", label: "Estafeta" }, { key: "d", pos: dest, icon: "dest", label: "Destino" }]} testid="tracking-map" />
          <RouteInfo route={route} />
          <p className={`text-xs ${stale ? "font-semibold text-amber-700" : "text-gray-500"}`} data-testid="tracking-last-update">
            Última localização recebida: {fmtDate(delivery.last_location.at)}{stale && " (pode não ser a posição atual)"}
          </p>
        </>
      ) : (
        <p className="text-xs text-gray-500" data-testid="tracking-no-location">
          {["picked_up", "in_transit"].includes(delivery.status) ? "O estafeta ainda não partilhou a localização." : "A localização do estafeta só é visível durante a entrega ativa."}
        </p>
      )}
    </section>
  );
}
